import { formDataToJson } from "src/Lib/Helper/Functions";
import { useState, useEffect } from "react";
import BioSpinner from "src/RCMP/BioSpinner";
import RequestHelper from "src/Lib/Helper/RequestHelper";
import { toast } from "react-toastify";

const RegisterFormStep2 = ({ email, onDone, back }) => {
    const [loader, setLoader] = useState(false);
    const [validated, setValidated] = useState(false);
    const [resendTimer, setResendTimer] = useState(120); // Resend timer state

    useEffect(() => {
        let timer;
        if (resendTimer > 0) {
            timer = setInterval(() => {
                setResendTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        }
        return () => clearInterval(timer); // Clear the timer when component unmounts
    }, [resendTimer]);

    const handleResendCode = async () => {
        setLoader(true);
        const res = await RequestHelper.post("NPAN_TSESSION", "/resend", { email });
        setLoader(false);

        if (res.success) {
            toast.success("Verification code resent successfully!");
            setResendTimer(120); // Reset the timer after a successful resend
        } else {
            toast.error(res.message || "Failed to resend verification code.");
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        if (event.target.checkValidity()) {
            const data = new FormData(event.target);
            const params = formDataToJson(data);
            setLoader(true);
            const res = await RequestHelper.post("NPAN_TSESSION", "/verify", {
                email: email,
                code: params.code,
                type: "register"
            });
            setLoader(false);
            if (res.success) {
                onDone(params.code);
            } else {
                toast.error(res.message);
            }
        } else {
            const list = event.target.querySelectorAll(":invalid");
            list[0].focus();
        }
    };

    return (
        <div className="w-100 text-center py-5">
            <form
                className="bg-gray-200 pb-4 rounded-lg px-3 max-w-full w-[400px] shadow-lg mx-auto"
                noValidate={validated}
                onSubmit={handleSubmit}
            >
                <div className="flex flex-col px-3 py-4 items-center gap-2 content-center">
                    <h1 className="font-bold font-20">Verify Code</h1>
                    <p>
                        Please enter the code that we have sent to <b>{email}</b>.
                    </p>
                </div>
                <div className="flex flex-col w-full items-start gap-1 font-14 content-center py-2">
                    <span>Verify Code:</span>
                    <input
                        type="text"
                        name="code"
                        required
                        className="border w-full rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        autoComplete="off"
                    />
                </div>
                <div className="flex gap-2 w-full my-4 flex-row">
                    <button
                        type="button"
                        onClick={back}
                        className="border border-black text-black justify-center items-center flex w-full w-100 rounded-md py-2 px-5"
                    >
                        {loader ? <BioSpinner animation="border" size="sm" /> : <span>Back</span>}
                    </button>
                    <button
                        className="bg-black justify-center items-center flex w-full text-white w-100 rounded-md py-2 px-5"
                    >
                        {loader ? <BioSpinner animation="border" size="sm" /> : <span>Verify</span>}
                    </button>
                </div>
                <div className="flex flex-col items-center mt-4">
                    <button
                        type="button"
                        onClick={handleResendCode}
                        disabled={resendTimer > 0 || loader} // Disable button during timer countdown or loader
                        className={`text-blue-500 font-bold ${
                            resendTimer > 0 || loader ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    >
                        {resendTimer > 0 ? `Resend Code (${resendTimer}s)` : "Resend Code"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default RegisterFormStep2;